import { getWithRootPathGetter } from '@/api/utils';

const withRoot = getWithRootPathGetter('/facilityservice');

export const geoApiPaths = {
  registry: withRoot('/geo-library'),
} as const;

export const getGeoApiUrl = {
  registry: () => geoApiPaths.registry,
};
